
$( document ).ready(function() {  
  $('.faq-tabs .tab:not(details):first-child').addClass('active');
  $('.faq-tabs .tab:not(details)').on('click', function() {
    var currentActive = $(this);
    $('.faq-tabs .tab:not(details)').removeClass('active');
    currentActive.addClass('active');
  });  
});

document.addEventListener("DOMContentLoaded", function() {
  var detailsElements = document.querySelectorAll("details.faq__details");

  detailsElements.forEach(function(detail) {
    detail.addEventListener("toggle", function() {
      if (detail.open) {
        // Close other details elements and remove the class
        // detailsElements.forEach(function(otherDetail) {
        //   if (otherDetail !== detail) {
        //     otherDetail.open = false;
        //     otherDetail.classList.remove("active");
        //   }
        // });
        // Add class to the opened detail
        setTimeout(()=> { detail.classList.add("active"); });
      } else {
        // Remove class if the detail is closed
        detail.classList.remove("active");
      }
    });
  });
  if(document.querySelector('[data-name="generate-quote"] [name="shipping estimates"]')){
    document.querySelector('[data-name="generate-quote"] [name="shipping estimates"]').addEventListener("click",function(e){
      if(e.target.checked){
        e.target.closest('.add-shipping').classList.add('open');
      }else{
        e.target.closest('.add-shipping').classList.remove('open');
      }
    })  
  }

  if(document.querySelector('[data-name="generate-quote"] [name="shipping estimates address"]')){
    document.querySelector('[data-name="generate-quote"] [name="shipping estimates address"]').addEventListener("click",function(e){
      if(e.target.checked){
        e.target.closest('.add-shipping-address').classList.add('open');
      }else{
        e.target.closest('.add-shipping-address').classList.remove('open');
      }
    })  
  }
  
});
$('a[href^=\"http\"]').attr('target', '_blank');

window.addEventListener("click", function(event) {
  if(event.target.classList.contains('popup') || event.target.classList.contains('popup-overlay')){
    if(document.querySelector('.popup-content[data-name="generate-quote"]')){
        if(document.querySelector('.popup-content[data-name="generate-quote"] .add-shipping').classList.contains('open')){
            document.querySelector('.popup-content[data-name="generate-quote"] .add-shipping').classList.remove('open');
        }
    }
    document.querySelector('.popup-content:not(.hide)').classList.add('hide');
    document.body.classList.remove('popup-show');
  }
  if(!event.target.closest('.active-drop')){
    if(document.querySelectorAll('.active-drop').length > 0){
      document.querySelector('.active-drop').classList.remove('active-drop');
    }
  }
});



function openPopup(ele){
    var chk_name = ele.getAttribute('data-name');
    if(document.querySelectorAll('.active-drop').length > 0){
      document.querySelector('.active-drop').classList.remove('active-drop');
    }
    document.body.classList.add('popup-show');
    ele.closest('.shopify-section').querySelector('.popup .popup-content[data-name="'+chk_name+'"]').classList.remove('hide');
}

function successPopup(ele){
    var chk_name = ele.getAttribute('data-name');
    if(document.querySelector('.popup-content:not(.hide)')){
      document.querySelector('.popup-content:not(.hide)').classList.add('hide');
    }
    if(document.querySelectorAll('.active-drop').length > 0){
      document.querySelector('.active-drop').classList.remove('active-drop');
    }
    document.body.classList.add('popup-show');
    ele.closest('.shopify-section').querySelector('.popup .popup-content[data-name="'+chk_name+'"]').classList.remove('hide');
}

function openSelect(open_select){
	if(document.querySelector('.custom-select.open') != null && document.querySelector('.custom-select.open') != open_select.closest('.custom-select')){
		document.querySelector('.custom-select.open').classList.remove('open');
	}
    open_select.closest('.custom-select').classList.toggle('open');
}

function select_items(select_li_items){
    if(select_li_items.closest('.custom-select').querySelector('.select-items .items.selected')){
        select_li_items.closest('.custom-select').querySelector('.select-items .items.selected').classList.remove('selected');
    }
    if(select_li_items.closest('.custom-select').querySelector('.select-selected').classList.contains('not-selected')){
        select_li_items.closest('.custom-select').querySelector('.select-selected').classList.remove('not-selected');
    }
    if(select_li_items.closest('.shipping-detalis')){
      select_li_items.closest('.field').querySelector('select').value = select_li_items.textContent;
      select_li_items.closest('.field').querySelector('select').dispatchEvent(new Event('change'),{bubble:true});
    }
    select_li_items.classList.add('selected');
    select_li_items.closest('.custom-select').querySelector('.select-selected').classList.add('selected');
    select_li_items.closest('.custom-select').querySelector('.select-selected').innerText = select_li_items.innerText;
    select_li_items.closest('.custom-select').classList.remove('open');
}

function GenerateQuote(ele){
  document.querySelector('.custom-saved-quotes').classList.add('hide');
  document.querySelector('.quote-file-section').classList.remove('hide');
  ele.closest('.shopify-section').querySelector('.popup-content:not(.hide)').classList.add('hide');
  document.body.classList.remove('popup-show');
}

function closePopup(ele){
    ele.closest('.shopify-section').querySelector('.popup-content:not(.hide)').classList.add('hide');
    document.body.classList.remove('popup-show');
}